import { render, staticRenderFns } from "./form-financial-general.vue?vue&type=template&id=e2ba132a&scoped=true"
import script from "./form-financial-general.vue?vue&type=script&lang=js"
export * from "./form-financial-general.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ba132a",
  null
  
)

export default component.exports